import React, { useState } from "react";
import screenshotTaaban1 from '../assets/images/Screenshot 2026-03-13 023044.png';
import screenshotTaaban2 from '../assets/images/Screenshot 2026-03-13 023103.png';
import screenshotTaaban3 from '../assets/images/Screenshot 2026-03-13 023023.png';
import banking1 from '../assets/images/banking1.png';
import { useLanguage } from '../i18n/LanguageProvider';
import '../assets/styles/Project.scss';

type ContextModule = {
    keys: () => string[];
    (id: string): string;
};

const getContextMedia = (context: ContextModule): string[] => {
    return context
        .keys()
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .map((key) => context(key));
};

const requireContext = require as unknown as {
    context: (path: string, scanSubDirs: boolean, regex: RegExp) => ContextModule;
};

const dashboardMedia = getContextMedia(requireContext.context('../assets/images/dashbaord_app', false, /\.(png|jpe?g|webp|avif)$/i));
const nciMedia = getContextMedia(requireContext.context('../assets/images/NCI_project', false, /\.(png|jpe?g|webp|avif)$/i));
const quizatyMedia = getContextMedia(requireContext.context('../assets/images/quizatty ', false, /\.(png|jpe?g|webp|avif)$/i));
const weatherMedia = getContextMedia(requireContext.context('../assets/images/weather_app', false, /\.(png|jpe?g|webp|avif)$/i));

const projectMedia = dashboardMedia;
const mediaByTitle: Record<string, string[]> = {
    'A2Z Desktop Dashboard': dashboardMedia,
    'لوحة تحكم A2Z': dashboardMedia,
    'NCI Post Graduate System': nciMedia,
    'نظام الدراسات العليا لمعهد الأورام': nciMedia,
    'Quizaty Platform': quizatyMedia,
    'منصة كويزاتي': quizatyMedia,
    'Weather App': weatherMedia,
    'تطبيق الطقس': weatherMedia,
    'Shaq El Taaban System': [screenshotTaaban1, screenshotTaaban2, screenshotTaaban3],
    'نظام شق التعبان': [screenshotTaaban1, screenshotTaaban2, screenshotTaaban3],
    'Data Preprocessing & Visualization Automation – EgyBank': [banking1],
    'أتمتة بيانات بنك EgyBank': [banking1],
};

type ProjectItem = {
    title: string;
    description: string;
    tech: string[];
    link?: string;
};

type ProjectCardProps = {
    project: ProjectItem;
    mediaList: string[];
};

function ProjectCard({ project, mediaList }: ProjectCardProps) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalImages = mediaList.length;

    const showPrevious = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setCurrentIndex((prev) => (prev - 1 + totalImages) % totalImages);
    };

    const showNext = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setCurrentIndex((prev) => (prev + 1) % totalImages);
    };

    const card = (
        <div className="project-card">
            <div className="project-media">
                <img
                    src={mediaList[currentIndex]}
                    className="zoom"
                    alt={project.title}
                    width="100%"
                    key={`${project.title}-${currentIndex}`}
                />
                {totalImages > 1 && (
                    <>
                        <button type="button" className="project-nav prev" onClick={showPrevious} aria-label="Previous image">
                            &#8249;
                        </button>
                        <button type="button" className="project-nav next" onClick={showNext} aria-label="Next image">
                            &#8250;
                        </button>
                        <span className="project-media-counter">{currentIndex + 1} / {totalImages}</span>
                    </>
                )}
            </div>
            <div className="project-body">
                <h2>{project.title}</h2>
                <p>{project.description}</p>
                <div className="project-badges">
                    {project.tech.map((label) => (
                        <span key={label} className="project-pill">{label}</span>
                    ))}
                </div>
            </div>
        </div>
    );

    if (project.link) {
        return (
            <a className="project-card-link" href={project.link} target="_blank" rel="noopener noreferrer">
                {card}
            </a>
        );
    }

    return card;
}

function Project() {
    const { t } = useLanguage();
    const projects = t('projects.items') as ProjectItem[];

    return(
    <div className="projects-container" id="projects">
        <div className="projects-header">
            <h1>{t('projects.title')}</h1>
            <p className="projects-subtitle">{t('projects.subtitle')}</p>
        </div>
        <div className="projects-grid">
            {projects.map((project, index) => {
                const mappedMedia = mediaByTitle[project.title];
                const fallbackMedia = projectMedia.length > 0
                    ? projectMedia[index % projectMedia.length]
                    : screenshotTaaban1;
                const mediaList = mappedMedia && mappedMedia.length > 0 ? mappedMedia : [fallbackMedia];

                return <ProjectCard key={project.title} project={project} mediaList={mediaList} />;
            })}
        </div>
    </div>
    );
}

export default Project;